// src/components/AnswerButtons.js
import React from "react";
import "./style.css";
import Archetype from "../Archetypes";
import GoldenButton from "../GoldenButton";
import archetypesContent from "../../data/archetypes.json";

const PageTutorial = ({ handleStartTest }) => {
  return (
    <main className="home-content">
      <header>
        <section>
          <div>
            <img src="./assets/teste-logo.png" alt="teste" className="img-teste-logo" />
            <span className="free-online-tag">Online e Gratuito</span>
            <div className="text-content">
              <h4>Identifique a sua DEUSA interior em poucos minutos! </h4>
              <h5>
                Revele Sua Identidade Feminina e Desperte Seus Dons Ocultos!
                <span className="bold-text"> Ative Suas DEUSAS </span>
                Interiores Hoje Mesmo!
              </h5>
            </div>
            <GoldenButton onClick={handleStartTest} content="Iniciar Teste" />
          </div>
        </section>
        <img src="./assets/goddess.png" alt="goddess" />
      </header>

      <section className="section-instructions">
        <div className="instructions-container">
          <div className="instructions-content-text">
            <h4>Teste: Identifique sua(s) DEUSA(s) Dominante(s) </h4>
            <h5>
              Leia as afirmações de cada sessão. Em seguida, atribua um valor para cada afirmação
              conforme se aplica mais ou menos a você:
            </h5>
            <br />
            <h5 className="bold-text">Veja o significado dos números abaixo:</h5>
            <br />
            <h5>
              <span className="bold-text">0</span> = a afirmação absolutamente não se aplica a mim
              <br />
              <span className="bold-text">1</span> = a afirmação só se aplica ligeiramente a mim
              <br />
              <span className="bold-text">2</span> = a afirmação aplica-se apenas à parte de mim
              <br />
              <span className="bold-text">3</span> = a afirmação aplica-se totalmente á mim
            </h5>
          </div>
          <img src="./assets/iphone-12-preview.png" alt="Imagem Preview" />
        </div>
      </section>
      <section className="archetypes">
        <h2>Conheça os Arquétipos das DEUSAS</h2>
        <div className="archetype-container">
          {archetypesContent.map((archetype, index) => (
            <Archetype
              url={archetype.url}
              name={archetype.name}
              textHeader={archetype.header}
              textContent={archetype.content}
              key={index}
            />
          ))}
        </div>
      </section>
      <section className="container-closing">
        <img src="./assets/teste-logo.png" alt="Imagem teste logo" className="img-teste-logo" />
        <span className="free-online-tag">Online e Gratuito</span>
        <GoldenButton onClick={handleStartTest} content="Iniciar Teste" />
      </section>
    </main>
  );
};

export default PageTutorial;
